export default __webpack_public_path__ + "static/marketing-652cfe94f735366bb9875fc1ccd7a8ee.jpg";